// In CSS, ID and NAME tokens must begin with a letter ([A-Za-z]) and may be followed by any number
// of letters, digits ([0-9]), hyphens ("-"), underscores ("_"), colons (":"), and periods (".").
// https://ghostinspector.com/blog/regex-validate-html-id-attribute/
export const isCssIdValid = (id: string): boolean => {
    const re = /^[A-Za-z]+[\w\-:.]*$/;

    return re.test(id);
};
